export var DynamicDialogButtonType;
(function (DynamicDialogButtonType) {
  DynamicDialogButtonType["Accept"] = "Accept";
  DynamicDialogButtonType["Exit"] = "Exit";
  DynamicDialogButtonType["Reject"] = "Reject";
  DynamicDialogButtonType["Delete"] = "Delete";
})(DynamicDialogButtonType || (DynamicDialogButtonType = {}));
